import { Col, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";

const AdditionalCostsFormHeader = () => {
  const { t } = useTranslation();

  return (
    <Row className="additional-costs-header" align="baseline" gutter={16}>
      <Col span={5}>
        <Typography.Text strong>
          {t("project:additionalCosts.type")}
        </Typography.Text>
      </Col>
      <Col span={6}>
        <Typography.Text strong>
          {t("project:additionalCosts.description")}
        </Typography.Text>
      </Col>
      <Col span={4}>
        <Typography.Text strong>
          {t("project:additionalCosts.precision")}
        </Typography.Text>
      </Col>
      <Col span={4}>
        <Typography.Text strong>
          {t("project:additionalCosts.source")}
        </Typography.Text>
      </Col>
      <Col span={4}>
        <Typography.Text strong>
          {t("project:additionalCosts.estimatedCost")}
        </Typography.Text>
      </Col>
      <Col />
    </Row>
  );
};

export default AdditionalCostsFormHeader;
